import { useEffect, useRef } from "react";

export const subscribeVisibleAccountRefresh = (refresh, { intervalMs = 30000 } = {}) => {
  let lastRefresh = 0;
  const update = () => {
    if (document.visibilityState === "hidden" || Date.now() - lastRefresh < 1000) return;
    lastRefresh = Date.now();
    refresh();
  };
  window.addEventListener("focus", update);
  document.addEventListener("visibilitychange", update);
  const timer = window.setInterval(update, intervalMs);
  return () => {
    window.removeEventListener("focus", update);
    document.removeEventListener("visibilitychange", update);
    window.clearInterval(timer);
  };
};

export const useVisibleAccountRefresh = (enabled, refresh) => {
  const callback = useRef(refresh);
  callback.current = refresh;
  useEffect(() => enabled ? subscribeVisibleAccountRefresh(() => callback.current()) : undefined, [enabled]);
};
